const isBoolean = (_: unknown): _ is boolean => typeof _ === 'boolean';

interface NavProps {
    collection?: any;
    creative?: any;
    location?: { state?: any } | null;
    isGridView?: any;
}

export const createNavDestination = (pathname: string, props: NavProps, pushCreative: boolean, search?: string) => {
    const { collection, creative, location, isGridView } = props;
    const state = location && location.state ? location.state : {};

    if (collection) {
        state.collection = collection;
    }

    if (isBoolean(isGridView)) {
        state.isGridView = isGridView;
    }

    state.creative = pushCreative ? creative : null;

    return {
        pathname,
        search,
        state,
    };
};
